/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { ESearchCctTypeListSearch } from './ESearchCctTypeListSearch';
import {
    ESearchCctTypeListSearchFromJSON,
    ESearchCctTypeListSearchFromJSONTyped,
    ESearchCctTypeListSearchToJSON,
} from './ESearchCctTypeListSearch';
import type { Int32ListSearch } from './Int32ListSearch';
import {
    Int32ListSearchFromJSON,
    Int32ListSearchFromJSONTyped,
    Int32ListSearchToJSON,
} from './Int32ListSearch';
import type { Int32NullableListSearch } from './Int32NullableListSearch';
import {
    Int32NullableListSearchFromJSON,
    Int32NullableListSearchFromJSONTyped,
    Int32NullableListSearchToJSON,
} from './Int32NullableListSearch';
import type { StringListSearch } from './StringListSearch';
import {
    StringListSearchFromJSON,
    StringListSearchFromJSONTyped,
    StringListSearchToJSON,
} from './StringListSearch';
import type { UnaccentTextSearch } from './UnaccentTextSearch';
import {
    UnaccentTextSearchFromJSON,
    UnaccentTextSearchFromJSONTyped,
    UnaccentTextSearchToJSON,
} from './UnaccentTextSearch';

/**
 * 
 * @export
 * @interface DashboardCctSearch
 */
export interface DashboardCctSearch {
    /**
     * 
     * @type {ESearchCctTypeListSearch}
     * @memberof DashboardCctSearch
     */
    visibility?: ESearchCctTypeListSearch;
    /**
     * 
     * @type {Int32ListSearch}
     * @memberof DashboardCctSearch
     */
    idcentre?: Int32ListSearch;
    /**
     * 
     * @type {Int32NullableListSearch}
     * @memberof DashboardCctSearch
     */
    idservice?: Int32NullableListSearch;
    /**
     * 
     * @type {Int32NullableListSearch}
     * @memberof DashboardCctSearch
     */
    idpri?: Int32NullableListSearch;
    /**
     * 
     * @type {Int32NullableListSearch}
     * @memberof DashboardCctSearch
     */
    idari?: Int32NullableListSearch;
    /**
     * 
     * @type {StringListSearch}
     * @memberof DashboardCctSearch
     */
    metier?: StringListSearch;
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof DashboardCctSearch
     */
    concerne?: UnaccentTextSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof DashboardCctSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof DashboardCctSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardCctSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardCctSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof DashboardCctSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardCctSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the DashboardCctSearch interface.
 */
export function instanceOfDashboardCctSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DashboardCctSearchFromJSON(json: any): DashboardCctSearch {
    return DashboardCctSearchFromJSONTyped(json, false);
}

export function DashboardCctSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardCctSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'visibility': !exists(json, 'visibility') ? undefined : ESearchCctTypeListSearchFromJSON(json['visibility']),
        'idcentre': !exists(json, 'idcentre') ? undefined : Int32ListSearchFromJSON(json['idcentre']),
        'idservice': !exists(json, 'idservice') ? undefined : Int32NullableListSearchFromJSON(json['idservice']),
        'idpri': !exists(json, 'idpri') ? undefined : Int32NullableListSearchFromJSON(json['idpri']),
        'idari': !exists(json, 'idari') ? undefined : Int32NullableListSearchFromJSON(json['idari']),
        'metier': !exists(json, 'metier') ? undefined : StringListSearchFromJSON(json['metier']),
        'concerne': !exists(json, 'concerne') ? undefined : UnaccentTextSearchFromJSON(json['concerne']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function DashboardCctSearchToJSON(value?: DashboardCctSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'visibility': ESearchCctTypeListSearchToJSON(value.visibility),
        'idcentre': Int32ListSearchToJSON(value.idcentre),
        'idservice': Int32NullableListSearchToJSON(value.idservice),
        'idpri': Int32NullableListSearchToJSON(value.idpri),
        'idari': Int32NullableListSearchToJSON(value.idari),
        'metier': StringListSearchToJSON(value.metier),
        'concerne': UnaccentTextSearchToJSON(value.concerne),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

